import { forwardRef } from 'react';
import setPath from '@/lib/setPath';

const Link = forwardRef((props, ref) => {
  const { replace, ...rest } = props;

  const doReplace = props.target ? false : props.replace;

  if (!props.to) {
    return <>{props.children}</>;
  }

  let fullPath = props.to;
  if (props?.to?.pathname) {
    for (const key in props.to.params) {
      if (!props.to.params[key]) {
        delete props.to.params[key];
      }
    }
    let params = new URLSearchParams(props?.to?.params || {}).toString();
    params = params ? `?${params}` : '';
    fullPath = `${props.to.pathname}${params || ''}`;
  }

  if (fullPath.includes('http') && props.target !== null) {
    return (
      <a ref={ref} className={props?.className} href={fullPath} onMouseEnter={props.onMouseEnter} target={'_blank'} rel="noreferrer" {...rest}>
        {props.children}
      </a>
    );
  }

  const handleClick = (e) => {
    // If it was not a pure left click, let the default <a> behavior handle it
    if (e.button !== 0 || e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) {
      return;
    }
    e.preventDefault();
    setPath(fullPath, { event: e, replace: doReplace, target: props.target });
  };

  return (
    <a ref={ref} className={props?.className} href={fullPath} onClick={handleClick} target={props.target} onMouseEnter={props.onMouseEnter} {...rest}>
      {props.children}
    </a>
  );
});

Link.displayName = 'Link';

export default Link;
